(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dignity-collection-grid"]) return;
  try {
    
  if (!customElements.get('dignity-collection-intro')) {
    customElements.define(
      'dignity-collection-intro',
      class DignityCollectionIntro extends HTMLElement {
        connectedCallback() {
          const description = this.querySelector('.dignity-collection-intro__description');
          const toggle = this.querySelector('.dignity-collection-intro__toggle');
          const readMore = this.querySelector('[data-read-more]');
          const readLess = this.querySelector('[data-read-less]');

          if (!description || !toggle || !readMore || !readLess) return;

          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            description.classList.toggle('is-collapsed', expanded);
            readMore.hidden = !expanded;
            readLess.hidden = expanded;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dignity-home-customers"] && !Shopify.designMode) return;
  try {
    
/* The review carousel's track behaviour, for the tracks inside this section only. */
(() => {
  function wire(track) {
    if (track.dataset.dhcReady) return;
    track.dataset.dhcReady = 'true';
    const cards = [...track.querySelectorAll('[data-dhc-card]')];
    if (!cards.length) return;
    let frame = 0;
    let dragStart = 0;
    let scrollStart = 0;
    let dragged = false;
    const update = () => {
      frame = 0;
      const box = track.getBoundingClientRect();
      const centre = box.left + box.width / 2;
      let active = cards[0];
      let closest = Infinity;
      cards.forEach(card => {
        const cardBox = card.getBoundingClientRect();
        const distance = Math.abs(cardBox.left + cardBox.width / 2 - centre);
        if (distance < closest) { closest = distance; active = card; }
      });
      cards.forEach(card => card.classList.toggle('is-active', card === active));
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const centreCard = (card, behavior = 'smooth') => {
      if (card) track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior });
    };
    requestAnimationFrame(() => { centreCard(cards[Math.min(1, cards.length - 1)], 'auto'); queue(); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const current = Math.max(0, cards.findIndex(card => card.classList.contains('is-active')));
      centreCard(cards[Math.min(cards.length - 1, Math.max(0, current + (event.key === 'ArrowRight' ? 1 : -1)))]);
    });
    track.addEventListener('focusin', event => {
      const card = event.target.closest('[data-dhc-card]');
      if (card && event.target.matches('a')) centreCard(card);
    });
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragStart = event.clientX;
      scrollStart = track.scrollLeft;
      dragged = false;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', event => {
      if (!track.classList.contains('is-dragging')) return;
      const distance = event.clientX - dragStart;
      if (Math.abs(distance) > 5) dragged = true;
      track.scrollLeft = scrollStart - distance;
    });
    const endDrag = event => {
      if (!track.classList.contains('is-dragging')) return;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      queue();
      setTimeout(() => { dragged = false; }, 0);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => {
      if (dragged) { event.preventDefault(); event.stopPropagation(); }
    }, true);
  }
  const start = () => document.querySelectorAll('.dignity-home-customers [data-dhc-track]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dignity-home-reviews"] && !Shopify.designMode) return;
  try {
    
/* The collection carousel's track behaviour (sections/dignity-opposite-carousel,
   itself the product page's), for the review tracks inside this section only. */
(() => {
  function wire(track) {
    if (track.dataset.dhrReady) return;
    track.dataset.dhrReady = 'true';
    const cards = [...track.querySelectorAll('[data-dhr-card]')];
    if (!cards.length) return;
    let frame = 0;
    let dragStart = 0;
    let scrollStart = 0;
    let dragged = false;
    const update = () => {
      frame = 0;
      const box = track.getBoundingClientRect();
      const centre = box.left + box.width / 2;
      let active = cards[0];
      let closest = Infinity;
      cards.forEach(card => {
        const cardBox = card.getBoundingClientRect();
        const distance = Math.abs(cardBox.left + cardBox.width / 2 - centre);
        if (distance < closest) { closest = distance; active = card; }
      });
      cards.forEach(card => card.classList.toggle('is-active', card === active));
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const centreCard = (card, behavior = 'smooth') => {
      if (card) track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior });
    };
    requestAnimationFrame(() => { centreCard(cards[Math.min(1, cards.length - 1)], 'auto'); queue(); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const current = Math.max(0, cards.findIndex(card => card.classList.contains('is-active')));
      centreCard(cards[Math.min(cards.length - 1, Math.max(0, current + (event.key === 'ArrowRight' ? 1 : -1)))]);
    });
    track.addEventListener('focusin', event => {
      const card = event.target.closest('[data-dhr-card]');
      if (card && event.target.matches('a')) centreCard(card);
    });
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragStart = event.clientX;
      scrollStart = track.scrollLeft;
      dragged = false;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', event => {
      if (!track.classList.contains('is-dragging')) return;
      const distance = event.clientX - dragStart;
      if (Math.abs(distance) > 5) dragged = true;
      track.scrollLeft = scrollStart - distance;
    });
    const endDrag = event => {
      if (!track.classList.contains('is-dragging')) return;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      queue();
      setTimeout(() => { dragged = false; }, 0);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => {
      if (dragged) { event.preventDefault(); event.stopPropagation(); }
    }, true);
  }
  const start = () => document.querySelectorAll('.dignity-home-reviews [data-dhr-track]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dignity-home-swipe-cards"] && !Shopify.designMode) return;
  try {
    
/* Swipe cards: the counter follows the scroll, the arrows step one card,
   mouse drag on desktop. Snap does the rest. */
(() => {
  function wire(root) {
    if (root.dataset.dscReady) return;
    root.dataset.dscReady = 'true';
    const track = root.querySelector('[data-dsc-track]');
    const cards = track ? [...track.querySelectorAll('[data-dsc-card]')] : [];
    if (!track || !cards.length) return;
    const current = root.querySelector('[data-dsc-current]');
    const prev = root.querySelector('[data-dsc-prev]');
    const next = root.querySelector('[data-dsc-next]');
    let frame = 0;
    let index = 0;
    let dragStart = 0;
    let scrollStart = 0;
    let dragged = false;
    const update = () => {
      frame = 0;
      const left = track.scrollLeft;
      const maxLeft = track.scrollWidth - track.clientWidth;
      let best = 0;
      let closest = Infinity;
      cards.forEach((card, i) => {
        const distance = Math.abs(card.offsetLeft - left);
        if (distance < closest) { closest = distance; best = i; }
      });
      /* At the end of the track (desktop, where the last cards share the view)
         the count reads the last card, so the arrows and the counter agree. */
      if (maxLeft > 0 && left >= maxLeft - 1) best = cards.length - 1;
      index = best;
      if (current) current.textContent = String(index + 1);
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= cards.length - 1;
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const goTo = (i, behavior = 'smooth') => {
      const card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (card) track.scrollTo({ left: card.offsetLeft, behavior });
    };
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragStart = event.clientX;
      scrollStart = track.scrollLeft;
      dragged = false;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', event => {
      if (!track.classList.contains('is-dragging')) return;
      const distance = event.clientX - dragStart;
      if (Math.abs(distance) > 5) dragged = true;
      track.scrollLeft = scrollStart - distance;
    });
    const endDrag = event => {
      if (!track.classList.contains('is-dragging')) return;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      queue();
      setTimeout(() => { dragged = false; }, 0);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => {
      if (dragged) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    update();
  }
  const start = () => document.querySelectorAll('.dignity-home-swipe-cards [data-dsc]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dignity-opposite-carousel"] && !Shopify.designMode) return;
  try {
    
/* The product page's recommendation-track behaviour (snippets/dignity-lords-style),
   for the tracks inside this section only. */
(() => {
  function wire(track) {
    if (track.dataset.docReady) return;
    track.dataset.docReady = 'true';
    const cards = [...track.querySelectorAll('[data-doc-card]')];
    if (!cards.length) return;
    let frame = 0;
    let dragStart = 0;
    let scrollStart = 0;
    let dragged = false;
    const update = () => {
      frame = 0;
      const box = track.getBoundingClientRect();
      const centre = box.left + box.width / 2;
      let active = cards[0];
      let closest = Infinity;
      cards.forEach(card => {
        const cardBox = card.getBoundingClientRect();
        const distance = Math.abs(cardBox.left + cardBox.width / 2 - centre);
        if (distance < closest) { closest = distance; active = card; }
      });
      cards.forEach(card => card.classList.toggle('is-active', card === active));
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const centreCard = (card, behavior = 'smooth') => {
      if (card) track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior });
    };
    requestAnimationFrame(() => { centreCard(cards[Math.min(1, cards.length - 1)], 'auto'); queue(); });
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const current = Math.max(0, cards.findIndex(card => card.classList.contains('is-active')));
      centreCard(cards[Math.min(cards.length - 1, Math.max(0, current + (event.key === 'ArrowRight' ? 1 : -1)))]);
    });
    track.addEventListener('focusin', event => {
      const card = event.target.closest('[data-doc-card]');
      if (card && event.target.matches('a')) centreCard(card);
    });
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragStart = event.clientX;
      scrollStart = track.scrollLeft;
      dragged = false;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', event => {
      if (!track.classList.contains('is-dragging')) return;
      const distance = event.clientX - dragStart;
      if (Math.abs(distance) > 5) dragged = true;
      track.scrollLeft = scrollStart - distance;
    });
    const endDrag = event => {
      if (!track.classList.contains('is-dragging')) return;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      queue();
      setTimeout(() => { dragged = false; }, 0);
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => {
      if (dragged) { event.preventDefault(); event.stopPropagation(); }
    }, true);
  }
  const start = () => document.querySelectorAll('.dignity-opposite-carousel [data-doc-track]').forEach(wire);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dignity-collection-carousel')) {
    customElements.define(
      'dignity-collection-carousel',
      class DignityCollectionCarousel extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-lords-recommendations]');
          const cards = [...this.querySelectorAll('[data-lords-recommendation-card]')];
          if (!track || !cards.length) return;

          let frame = 0;
          let dragStart = 0;
          let scrollStart = 0;
          let dragged = false;

          const update = () => {
            frame = 0;
            const box = track.getBoundingClientRect();
            const centre = box.left + box.width / 2;
            let active = cards[0];
            let closest = Infinity;

            cards.forEach((card) => {
              const cardBox = card.getBoundingClientRect();
              const distance = Math.abs(cardBox.left + cardBox.width / 2 - centre);
              if (distance < closest) {
                closest = distance;
                active = card;
              }
            });

            cards.forEach((card) => card.classList.toggle('is-active', card === active));
          };

          const queue = () => {
            if (!frame) frame = requestAnimationFrame(update);
          };

          const centreCard = (card, behavior = 'smooth') => {
            if (!card) return;
            track.scrollTo({
              left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
              behavior
            });
          };

          requestAnimationFrame(() => {
            centreCard(cards[Math.min(1, cards.length - 1)], 'auto');
            queue();
          });

          track.addEventListener('scroll', queue, { passive: true });
          track.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const current = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
            const next = Math.min(cards.length - 1, Math.max(0, current + (event.key === 'ArrowRight' ? 1 : -1)));
            centreCard(cards[next]);
          });

          track.addEventListener('focusin', (event) => {
            centreCard(event.target.closest('[data-lords-recommendation-card]'));
          });

          track.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            dragStart = event.clientX;
            scrollStart = track.scrollLeft;
            dragged = false;
            track.classList.add('is-dragging');
            track.setPointerCapture(event.pointerId);
          });

          track.addEventListener('pointermove', (event) => {
            if (!track.classList.contains('is-dragging')) return;
            const distance = event.clientX - dragStart;
            if (Math.abs(distance) > 5) dragged = true;
            track.scrollLeft = scrollStart - distance;
          });

          const endDrag = (event) => {
            if (!track.classList.contains('is-dragging')) return;
            track.classList.remove('is-dragging');
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            queue();
            setTimeout(() => {
              dragged = false;
            }, 0);
          };

          track.addEventListener('pointerup', endDrag);
          track.addEventListener('pointercancel', endDrag);
          track.addEventListener(
            'click',
            (event) => {
              if (!dragged) return;
              event.preventDefault();
              event.stopPropagation();
            },
            true
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.isDignityHeader = this.hasAttribute('data-dignity-header');
      if (this.isDignityHeader) {
        this.dignityMobileQuery = window.matchMedia('(max-width: 989px)');
        this.onDignityModeChange = this.updateDignityStickyMode.bind(this);
        this.dignityMobileQuery.addEventListener('change', this.onDignityModeChange);
        this.onDignityFocus = () => {
          cancelAnimationFrame(this.dignityScrollFrame);
          this.dignityScrollDistance = 0;
          this.reveal();
        };
        this.addEventListener('focusin', this.onDignityFocus);
        this.updateDignityStickyMode();
        if ('ResizeObserver' in window) {
          this.dignityResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
          this.dignityResizeObserver.observe(this.header);
        }
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.dignityMobileQuery?.removeEventListener('change', this.onDignityModeChange);
      this.removeEventListener('focusin', this.onDignityFocus);
      this.dignityResizeObserver?.disconnect();
      cancelAnimationFrame(this.dignityScrollFrame);
      window.clearTimeout(this.isScrolling);
    }

    updateDignityStickyMode() {
      cancelAnimationFrame(this.dignityScrollFrame);
      this.headerIsAlwaysSticky = !this.dignityMobileQuery.matches;
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      this.currentScrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);
      this.dignityScrollDistance = 0;
      this.setHeaderHeight();
    }

    onDignityScroll(scrollTop) {
      const delta = scrollTop - this.currentScrollTop;
      this.currentScrollTop = scrollTop;

      // Keep navigation steady while a drawer, search or another dialog is open.
      if (this.preventHide || this.preventReveal || this.predictiveSearch?.isOpen ||
          this.header.classList.contains('menu-open') ||
          document.body.classList.contains('overflow-hidden') ||
          document.body.classList.contains('overflow-hidden-mobile') ||
          this.querySelector('details[open]')) {
        cancelAnimationFrame(this.dignityScrollFrame);
        this.dignityScrollDistance = 0;
        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        }
        return;
      }

      if (scrollTop <= this.header.offsetHeight) {
        cancelAnimationFrame(this.dignityScrollFrame);
        this.dignityScrollDistance = 0;
        this.header.classList.remove('scrolled-past-header');
        this.reveal();
        return;
      }

      if (delta === 0) return;

      // Accumulate a short deliberate scroll; do not react to one-pixel jitter.
      if (Math.sign(delta) !== Math.sign(this.dignityScrollDistance)) this.dignityScrollDistance = 0;
      this.dignityScrollDistance += delta;
      if (Math.abs(this.dignityScrollDistance) < 12) return;

      const scrollingDown = this.dignityScrollDistance > 0;
      this.dignityScrollDistance = 0;
      this.header.classList.add('scrolled-past-header');
      cancelAnimationFrame(this.dignityScrollFrame);
      this.dignityScrollFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !this.dignityMobileQuery.matches) return;
        if (this.header.classList.contains('menu-open') || this.querySelector('details[open]') ||
            document.body.classList.contains('overflow-hidden') ||
            document.body.classList.contains('overflow-hidden-mobile')) return;
        scrollingDown ? this.hide() : this.reveal();
      });
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);

      if (this.isDignityHeader && this.dignityMobileQuery.matches) {
        this.onDignityScroll(scrollTop);
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('dignity-collection-intro')) {
    customElements.define(
      'dignity-collection-intro',
      class DignityCollectionIntro extends HTMLElement {
        connectedCallback() {
          const description = this.querySelector('.dignity-collection-intro__description');
          const toggle = this.querySelector('.dignity-collection-intro__toggle');
          const readMore = this.querySelector('[data-read-more]');
          const readLess = this.querySelector('[data-read-less]');

          if (!description || !toggle || !readMore || !readLess) return;

          toggle.addEventListener('click', () => {
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!expanded));
            description.classList.toggle('is-collapsed', expanded);
            readMore.hidden = !expanded;
            readLess.hidden = expanded;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
